/** parsePassesFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parsePassesFilters = (params /* URLSearchParams */) => ({
  // Filters
  norad_ids: params.get("norad_ids"),
  object_ids: params.get("object_ids"), // typically the noirad ID but can differ if the object is a custom user created object
  astrosite_id: params.get("astrosite_id"),
  orbit_regime: params.get("orbit_regime"),
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  sort_order: params.get("sort_order"), // The sort order
  sort_by: params.get("sort_by"), // The column to sort by
})
